// extracted by mini-css-extract-plugin
export var checkbox = "style-module--checkbox--e4235";
export var checkboxLabel = "style-module--checkboxLabel--fec4b";
export var checkboxRow = "style-module--checkboxRow--651b4";